import classNames from 'classnames';
import { FC, useEffect } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import styles from './Spinner.module.scss';
import './Spinner.scss';

import { ReactComponent as Logo } from '../../../../assets/images/apg.svg';

{/* prettier-ignore */}
export interface ISpinnerV2 {
    button?: boolean;
    color?: string;
    fullScreen?: boolean;
    headerText?: string;
    inText?: boolean;
    loadMore?: boolean;
    relative?: boolean;
    style?: { [index: string]: string };
    text?: string;
}

const SpinnerV2: FC<ISpinnerV2> = ({ fullScreen, relative, style, text, headerText }) => {
    useEffect(() => {
        fullScreen && document.documentElement.classList.add('scrollHidden');
        // returned function will be called on component unmount
        return () => {
            document.documentElement.classList.remove('scrollHidden');
        };
    }, [fullScreen]);

    const LoaderBlock = (
        <div className={styles.wrapper}>
            <div className={styles.loader}>
                <svg version="1.1" id="loader-1" x="0px" y="0px" viewBox="0 0 50 50">
                    <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                        <animateTransform
                            attributeType="xml"
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="0.8s"
                            repeatCount="indefinite"
                        />
                    </path>
                </svg>
            </div>

            <div className={styles.logo}>
                <Logo />
            </div>

            <p className={styles.semiText}>{headerText}</p>
            <p className={styles.smallText}>{text}</p>
        </div>
    );

    return relative ? (
        <SwitchTransition mode="out-in">
            <CSSTransition in={true} timeout={{ enter: 500, exit: 500 }} classNames="my-node">
                <div style={style} className={classNames(styles.loading, styles.inText, { [styles.relative]: relative })}>
                    {LoaderBlock}
                </div>
            </CSSTransition>
        </SwitchTransition>
    ) : (
        <SwitchTransition mode="in-out">
            <CSSTransition in={true} timeout={500} classNames="my-node">
                <div style={style} className={classNames(styles.loading, { [styles.relative]: relative })}>
                    {LoaderBlock}
                </div>
            </CSSTransition>
        </SwitchTransition>
    );
};
export default SpinnerV2;
